import React from 'react';

import PriceRange from './PriceRange';

import Swatches from './Swatches';
import List from './List';

// Types
import { FilterItem } from '@src/types/search';

interface SearchFilterProps {
  filter: FilterItem;
  appliedFilters: any;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ filter, appliedFilters }) => {
  const { label, type, presentation } = filter;

  const handleUpdateFilter = (input: string, applying: boolean, filterId: string, value: string) => {
    if (!input) return;

    const filterEvent = new CustomEvent('searchrequest-filter-applied', {
      detail: {
        input,
        applying,
        type: 'header-search',
        filterId,
        value
      }
    });

    window.dispatchEvent(filterEvent);
  };

  return (
    <div className='w-full'>
      {type === 'PRICE_RANGE' && <PriceRange filter={filter} />}

      {type === 'LIST' && presentation !== 'SWATCH' && (
        <List
          filter={filter}
          onFilterUpdate={handleUpdateFilter}
          appliedFilters={appliedFilters}
        />
      )}

      {presentation === 'SWATCH' && (
        <Swatches
          filter={filter}
          onFilterUpdate={handleUpdateFilter}
          appliedFilters={appliedFilters}
        />
      )}
    </div>
  );
};

export default SearchFilter;
